"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=LogFn.js.map